/**
 * Estilos compartilhados entre os sub-componentes do perfil do aluno.
 *
 * Tudo que aparece em 2+ componentes (sectionTitle, card, fieldRow,
 * input, linkText, etc) vive aqui. Estilos exclusivos de UM componente
 * ficam no próprio arquivo dele.
 *
 * Decisões:
 *   - Mantemos as cores hardcoded por enquanto (sem theme system).
 *     A primária `#C8102E` é regra Aratek — NUNCA trocar por outra.
 *   - `inputMultiline` tem `textAlignVertical: 'top'` porque sem isso
 *     o Android centraliza o texto vertical (UX ruim em multi-linha).
 */

import { StyleSheet } from 'react-native';

export const sharedStyles = StyleSheet.create({
  sectionTitle: {
    fontSize: 11,
    fontWeight: '700',
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    marginTop: 16,
    marginBottom: 6,
  },
  section: { marginTop: 8 },
  sectionRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
    marginTop: 16,
  },
  card: { backgroundColor: '#fff', borderRadius: 12, padding: 14, gap: 2 },
  fieldRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 7,
    borderBottomWidth: 1,
    borderBottomColor: '#f5f5f5',
  },
  fieldLabel: { fontSize: 13, color: '#888', flex: 1 },
  fieldValue: { fontSize: 13, fontWeight: '600', color: '#1A1A1A', flex: 1, textAlign: 'right' },
  bodyText: { fontSize: 14, color: '#1A1A1A', lineHeight: 20 },
  input: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 8,
    padding: 10,
    fontSize: 14,
    color: '#1A1A1A',
    marginBottom: 8,
  },
  inputMultiline: { height: 72, textAlignVertical: 'top' },
  linkText: { fontSize: 13, color: '#C8102E', fontWeight: '600' },
  empty: { color: '#aaa', fontSize: 14, marginTop: 4 },
});
